$(function handleTabs() {
    const $tabsSections = $('.tabs-sections');

    $.each($tabsSections, (_index, section) => {
        const $tabsLinks = $(section).find('.tabs-navigation a');
        const $tabsPanels = $(section).find('.tab-panel');

        $tabsLinks.first().addClass('active');
        $tabsPanels.first().addClass('show');

        $.each($tabsLinks, (index, link) => {
            if (index === 0) {
                showAndHideTabs(link, $tabsLinks, $tabsPanels);
            }
            $(link).click(e => {
                e.preventDefault();

                showAndHideTabs(link, $tabsLinks, $tabsPanels);
            });
        });
    });
});

const showAndHideTabs = (link, $tabsLinks, $tabsPanels) => {
    const tabAnchor = link.hash.slice(1);
    const $tabPanel = $tabsPanels.filter(`.${tabAnchor}`);

    $tabsPanels.filter('.show').hide('fade', () => {
        $tabPanel.show('fade');
    });

    $tabsLinks.removeClass('active');
    $tabsPanels.removeClass('show');
    $(link).addClass('active');
    $tabPanel.addClass('show');
};



// WEBPACK FOOTER //
// ./js/investor-relations-reports-tabs.js